import { FC } from 'react';
import { Avatar, Theme } from '@mui/material';
import Icon from '@/components/icon';
import { createUseStyles } from 'react-jss';
import { getInitials } from '@/lib/helpers';
import { OrgBrandingTheme } from '@/lib/models/org';

interface Props {
  name: string;
  mode: OrgBrandingTheme;
}

const useStyles = createUseStyles<string, { mode: OrgBrandingTheme }>((theme: Theme) => ({
  portalDefaultBadge: {
    backgroundColor: '#7ebd94',
    color: ({ mode }) =>
      mode === 'dark' ? theme.palette.common.black : theme.palette.common.white,
  },
}));

const PortalDefaultBadge: FC<Props> = ({ name, mode }) => {
  const styles = useStyles({ mode });

  const initials = getInitials(name);
  const hasName = !!initials;

  return (
    <span>
      {hasName && <Avatar className={styles.portalDefaultBadge}>{initials}</Avatar>}
      {!hasName && (
        <Avatar className={styles.portalDefaultBadge}>
          <Icon name="person" color="white" />
        </Avatar>
      )}
    </span>
  );
};

export default PortalDefaultBadge;
